import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { statNumberToString } from "../../../apis/transform/stats"
import { Progress } from "antd"

export function PlayerGoals({ goals, penaltyGoals }: { goals: number; penaltyGoals: number }) {
  return (
    <Col className={"colStats"}>
      <Row>
        <Col sm={6} className={"centerColumn"}>
          <Row>
            <Col className={"competitionSeasonValueLarge"}>{statNumberToString(goals)}</Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>Gol</Col>
          </Row>
        </Col>
        <Col sm={6} className={"centerColumn"}>
          <Row>
            <Col className={"competitionSeasonValue"}>{`${statNumberToString(penaltyGoals)}`}</Col>
          </Row>
          <Row>
            <Col>
              <Progress
                className={"paddingLeftRight15"}
                percent={(penaltyGoals / (goals || 1)) * 100}
                size="small"
                showInfo={false}
                strokeLinecap={"square"}
                strokeColor={"#f4c400"}
                trailColor="white"
              />
            </Col>
          </Row>
          <Row>
            <Col className={"competitionSeasonLabel"}>Su rigore</Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}
